// One money formatter for the app. Compact for large figures in stat cards, rows and totals
// ($2.64M, $850K, $47.3K); exact everywhere precision matters (invoices, checkout, payout
// line items, contracts, tax). Compact values carry the exact amount in a title tooltip.
const exactFmt = new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD", maximumFractionDigits: 0 });

export function fmtMoneyExact(v) {
  if (v == null || v === "" || Number.isNaN(Number(v))) return "—";
  return exactFmt.format(Number(v)).replace("CA$", "$");
}

function trim(n, digits) {
  return Number(n.toFixed(digits)).toString();
}

/** $2.64M · $850K · $47.3K · $9,800 (exact below $10K). */
export function fmtMoneyCompact(v) {
  if (v == null || v === "" || Number.isNaN(Number(v))) return "—";
  const n = Number(v), a = Math.abs(n), s = n < 0 ? "-" : "";
  if (a >= 1e9) return `${s}$${trim(a / 1e9, a >= 1e10 ? 1 : 2)}B`;
  if (a >= 1e6) return `${s}$${trim(a / 1e6, a >= 1e8 ? 0 : a >= 1e7 ? 1 : 2)}M`;
  if (a >= 1e4) return `${s}$${trim(a / 1e3, a >= 1e5 ? 0 : 1)}K`;
  return fmtMoneyExact(n);
}

/** <Money value={2638000} /> → "$2.64M" with the exact amount on hover. */
export function Money({ value, exact = false, style, className }) {
  const full = fmtMoneyExact(value);
  const text = exact ? full : fmtMoneyCompact(value);
  return <span className={className} style={style} title={text !== full ? full : undefined}>{text}</span>;
}
